const AppConstants = {
  gAuthDetails: {
    clientId: '797749045300-48asg0koqf5aa9npc40kmch9r754dl87.apps.googleusercontent.com',
    scopes: ['https://www.googleapis.com/auth/drive.appdata', 'https://www.googleapis.com/auth/plus.me']
  }
};

export default AppConstants;


/** WEBPACK FOOTER **
 ** ./src/app/constants.ts
 **/